import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleTagManagerAutoStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '40px',
  width: '230px',

  variants: {
    noMargin: {
      true: {
        marginLeft: '0',
      },
    },
  },
})

export const GoogleTagManagerAutoText = styled('div', {
  fontSize: '$md',
  fontWeight: '$sb',
  marginBottom: '$6',
  display: 'flex',
})
export const GoogleTagManagerAutoError = styled('div', {
  fontSize: '$sm',
  fontWeight: '$sb',
  marginTop: '$6',
  color: '$error',
})

export const GoogleTagManagerAutoSuccess = styled('div', {
  fontSize: '$sm',
  fontWeight: '$sb',
  marginLeft: '$6',
  color: '$successColor',
  background: '$lightGreen',
  height: '18px',
  padding: '$3',
})

export const GreyItalicText = styled('div', {
  color: '$neutral',
  fontStyle: 'italic',
})

export const ForMoreDetails = styled('div', {
  fontSize: '$sm',
  fontWeight: '$l',
  marginTop: '$8',
  fontStyle: 'italic',
})
